import { useCallback } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

export function useReelNavigate() {
    const navigate = useNavigate()
    const location = useLocation()

    const handleCloseClick = useCallback(() => {
        const backgroundPath = (location.state)?.backgroundPath
        navigate(backgroundPath || '/')
    }, [location.state, navigate])

    const handleSettingsClick = useCallback(() => {
        navigate('/settings/account/privacy-and-security/discovery-settings')
    }, [navigate])

    return { handleCloseClick, handleSettingsClick }
}